import React from 'react';
import { Box, Button, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { ComponentInfo, ListTextAnimation } from '@components';
import { rem } from '@helpers';
import { useNavigation } from '@navigation';

export const IntroWizardPlaceholder: React.FC = () => {
	const { navigate } = useNavigation();
	const t = useTranslation();
	const resources = {
		titleOne: t('placeholder.wizardIntro.title.one'),
		titleTwo: t('placeholder.wizardIntro.title.two'),
		subtitle: t('placeholder.wizardIntro.subtitle'),
		buttonText: t('placeholder.wizardIntro.button.text'),
	};
	return (
		<ComponentInfo name="WizardIntroPlaceholder">
			<Box
				styles={{
					flexDirection: 'column',
					height: '100%',
					width: '100%',
					alignContent: 'center',
					alignItems: 'flex-start',
					justifyContent: 'center',
					margin: rem(0, 40, 140),
				}}
			>
				<Typography appearance="headline-200-02">{resources.titleOne}</Typography>
				<Typography appearance="headline-200-02">{resources.titleTwo}</Typography>
				<Spacer vertical={rem(16)} />
				<Typography appearance="subtitle-100-02">{resources.subtitle}</Typography>
				<Spacer vertical={rem(32)} />
				<Button
					size={'xLarge'}
					onPress={() => {
						navigate('subscriptionSelectPlan');
					}}
				>
					{resources.buttonText}
				</Button>
				<ListTextAnimation />
			</Box>
		</ComponentInfo>
	);
};
